// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1QP5y","col":"styles_col__1NKdv"};